module.exports = __webpack_public_path__ + "static/media/escolhaMultipla.1641af6a.jpg";